import ReactDom from 'react-dom';
import MessageBase from './messageBase';

const getDefaultKey = () => Math.random().toString(36).substr(2);

const nodes = {};

const container = window.__POWERED_BY_QIANKUN__
  ? document.querySelector('#newwaitlistAppContainer').querySelector('#root')
  : document.body;

const unmount = (key) => {
  const node = nodes[key];
  ReactDom.unmountComponentAtNode(node);
  container.removeChild(node);
  delete nodes[key];
};

const close = (key) => {
  if (key) return unmount(key);
  Object.keys(nodes).forEach(unmount);
};

const messageFactory = (params) => {
  const { duration } = params;
  const key = getDefaultKey();
  const node = document.createElement('div');
  nodes[key] = node;
  container.appendChild(node);
  ReactDom.render(<MessageBase key={key} {...params} onClose={() => close(key)} />, node);
  const timer = setTimeout(() => {
    if (nodes[key]) {
      unmount(key);
    }
    clearTimeout(timer);
  }, duration);
};

const message = {
  success({ content, duration = 2500 }) {
    messageFactory({ content, duration, type: 'success' });
  },
  error({ content, duration = 2500 }) {
    messageFactory({ content, duration, type: 'error' });
  },
  info({ content, duration = 2500 }) {
    messageFactory({ content, duration, type: 'info' });
  },
  warning({ content, duration = 2500 }) {
    messageFactory({ content, duration, type: 'warning' });
  },
  Unauthorized({ content, duration = 2500, title }) {
    messageFactory({ content, duration, type: 'error', isShowTitle: true, title });
  },
};

export default message;
